import React from 'react';
import { FairnessCalculator } from '../fairness/FairnessCalculator';

export const KenoVerifyForm = ({ game, revealed }) => <FairnessCalculator key={game.owner} game={{ ...game, gameType: 'keno' }} revealed={revealed} />;